import { siteConfig } from "../data/siteConfig";
import { BrandMark } from "./BrandMark";

export function Footer() {
  const cleanPhone = siteConfig.contactPhone.replace(/\D/g, "");

  return (
    <footer className="site-footer">
      <div className="site-shell site-footer__inner">
        <div className="site-footer__brand">
          <BrandMark compact invert />
          <span>&copy; {siteConfig.year} Subedi Tax Pro &middot; Based in Sacramento County, California</span>
          <span className="site-footer__entity">
            Subedi Tax Pro is a service of Gaurab Subedi, Sole Proprietor &middot;{" "}
            {siteConfig.ctecNumber ? `CTEC CRTP ${siteConfig.ctecNumber} \u00b7 ` : ""}County License{" "}
            {siteConfig.countyLicense}
          </span>
          {/* Fee-based preparers advertise outcomes at their peril: nothing on this site promises a
              refund, a refund size, or a turnaround a complex return cannot keep. Say so plainly. */}
          <span className="site-footer__disclaimer">
            Subedi Tax Pro does not guarantee any particular refund, tax outcome, or filing result.
            Turnaround estimates apply to simple returns and depend on the completeness of the
            information you provide. Nothing on this site is tax or legal advice.
          </span>
        </div>
        <div className="site-footer__links">
          <a href={`tel:${cleanPhone}`}>{siteConfig.contactPhone}</a>
          <a href={`mailto:${siteConfig.contactEmail}`}>{siteConfig.contactEmail}</a>
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
}
